<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <div
        class="wcdiv"
        style="
          left: -0.05pt;
          top: -0.05pt;
          width: 175.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        <br />
      </div>
      <span
        class="wcspan wctext002"
        style="font-size: 16pt; left: 0pt; top: 1.61pt"
        >第七部份：咀嚼吞嚥評估</span
      >
      <div class="wcdiv" style="top: 20.8pt">
        <span
          class="wcspan wctext002"
          style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
          >1.吞嚥能力評估(EAT-10)</span
        >
      </div>
      <div class="wcdiv" style="top: 38.8pt">
        <div class="wcdiv" style="clip: rect(0.5pt, 205.55pt, 19.5pt, 0pt)">
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
              >3</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 12.5pt; left: 9.38pt; top: 2.13pt"
              >個月內是否有以下問題</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 205.55pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 1.78pt; top: 2.96pt"
              >沒有(0</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 37.53pt; top: 2.96pt"
              >分)</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 272.15pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 1.78pt; top: 2.96pt"
              >很少(1</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 37.53pt; top: 2.96pt"
              >分)</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 338.75pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 1.78pt; top: 2.96pt"
              >偶爾(2</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 37.53pt; top: 2.96pt"
              >分)</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 405.35pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 1.78pt; top: 2.96pt"
              >經常(3</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 37.53pt; top: 2.96pt"
              >分)</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 471.95pt; clip: rect(0.5pt, 66.65pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 1.8pt; top: 2.96pt"
              >嚴重(4</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 11pt; left: 37.55pt; top: 2.96pt"
              >分)</span
            >
          </div>
        </div>
        <div class="wcdiv" style="top: 18.5pt">
          <div class="wcdiv" style="clip: rect(0.5pt, 29.55pt, 19.5pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >1.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0.5pt, 176pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >吞嚥問題讓我的體重減輕</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-1.吞嚥問題讓我的體重減輕", "0.沒有", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-1.吞嚥問題讓我的體重減輕", "1.很少", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-1.吞嚥問題讓我的體重減輕", "2.偶爾", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0.5pt, 66.6pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-1.吞嚥問題讓我的體重減輕", "3.經常", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0.5pt, 66.65pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{
                  ifq("1-1.吞嚥問題讓我的體重減輕", "4.嚴重", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 37pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >2.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >因為吞嚥問題不能在外面用餐</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-2.因為吞嚥問題不能在外面用餐", "0.沒有", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-2.因為吞嚥問題不能在外面用餐", "1.很少", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-2.因為吞嚥問題不能在外面用餐", "2.偶爾", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-2.因為吞嚥問題不能在外面用餐", "3.經常", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{
                  ifq("1-2.因為吞嚥問題不能在外面用餐", "4.嚴重", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 55pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >3.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >我喝飲料/水很費力</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-3.我喝飲料/水很費力", "0.沒有", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-3.我喝飲料/水很費力", "1.很少", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-3.我喝飲料/水很費力", "2.偶爾", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-3.我喝飲料/水很費力", "3.經常", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{ ifq("1-3.我喝飲料/水很費力", "4.嚴重", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 73pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >4.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >我吃固體食物很費力</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-4.我吃固體食物很費力", "0.沒有", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-4.我吃固體食物很費力", "1.很少", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-4.我吃固體食物很費力", "2.偶爾", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-4.我吃固體食物很費力", "3.經常", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{ ifq("1-4.我吃固體食物很費力", "4.嚴重", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 91pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >5.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >我吞藥丸很費力</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-5.我吞藥丸很費力", "0.沒有", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-5.我吞藥丸很費力", "1.很少", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-5.我吞藥丸很費力", "2.偶爾", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-5.我吞藥丸很費力", "3.經常", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{ ifq("1-5.我吞藥丸很費力", "4.嚴重", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 109pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >6.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >吞嚥會感覺到痛</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-6.吞嚥會感覺到痛", "0.沒有", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-6.吞嚥會感覺到痛", "1.很少", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-6.吞嚥會感覺到痛", "2.偶爾", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-6.吞嚥會感覺到痛", "3.經常", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{ ifq("1-6.吞嚥會感覺到痛", "4.嚴重", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 127pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >7.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >因為吞嚥問題不能享受用餐</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-7.因為吞嚥問題不能享受用餐", "0.沒有", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-7.因為吞嚥問題不能享受用餐", "1.很少", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-7.因為吞嚥問題不能享受用餐", "2.偶爾", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-7.因為吞嚥問題不能享受用餐", "3.經常", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{
                  ifq("1-7.因為吞嚥問題不能享受用餐", "4.嚴重", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 145pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >8.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >吞嚥後感覺喉嚨有食物卡著</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-8.吞嚥後感覺喉嚨有食物卡著", "0.沒有", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-8.吞嚥後感覺喉嚨有食物卡著", "1.很少", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-8.吞嚥後感覺喉嚨有食物卡著", "2.偶爾", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-8.吞嚥後感覺喉嚨有食物卡著", "3.經常", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{
                  ifq("1-8.吞嚥後感覺喉嚨有食物卡著", "4.嚴重", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 163pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >9.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >當我進食的時候會咳嗽</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-9.當我進食的時候會咳嗽", "0.沒有", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-9.當我進食的時候會咳嗽", "1.很少", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-9.當我進食的時候會咳嗽", "2.偶爾", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{ ifq("1-9.當我進食的時候會咳嗽", "3.經常", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{ ifq("1-9.當我進食的時候會咳嗽", "4.嚴重", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 181pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >10.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 176pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >吞嚥讓我感覺緊張有壓力</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 205.55pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-10.吞嚥讓我感覺緊張有壓力", "0.沒有", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 272.15pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-10.吞嚥讓我感覺緊張有壓力", "1.很少", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 338.75pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-10.吞嚥讓我感覺緊張有壓力", "2.偶爾", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 405.35pt; clip: rect(0pt, 66.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.65pt; top: 2.13pt"
                >{{
                  ifq("1-10.吞嚥讓我感覺緊張有壓力", "3.經常", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 471.95pt; clip: rect(0pt, 66.65pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 21.68pt; top: 2.13pt"
                >{{
                  ifq("1-10.吞嚥讓我感覺緊張有壓力", "4.嚴重", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 199pt">
          <div class="wcdiv" style="clip: rect(0.5pt, 538.6pt, 19.5pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >總分：</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 58pt; top: 0pt"
                >&nbsp;{{ scoreA }}</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 100pt; top: 2.13pt"
                >分 (注意：若分數≧ 3 分，即「可能」有吞嚥障礙風險</span
              >
              <div
                class="wcdiv"
                style="
                  left: 37.5pt;
                  top: 14.34pt;
                  width: 62.5pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
            </div>
          </div>
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 0pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 18.5pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 199pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 217.5pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="top: 256.8pt">
        <span
          class="wcspan wctext002"
          style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
          >2.咀嚼能力篩檢量表：</span
        >
      </div>
      <div class="wcdiv" style="top: 274.8pt">
        <div class="wcdiv" style="clip: rect(0.5pt, 233.9pt, 19.5pt, 0pt)">
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span
              class="wcspan wctext001"
              style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
              >6</span
            >
            <span
              class="wcspan wctext001"
              style="font-size: 12.5pt; left: 9.38pt; top: 2.13pt"
              >個月內咀嚼能力評估</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 233.9pt; clip: rect(0.5pt, 101.55pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext001" style="left: 27.38pt; top: 2.41pt"
              >容易吃</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 335.45pt; clip: rect(0.5pt, 101.55pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext001" style="left: 21.38pt; top: 2.41pt"
              >有些吃力</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 437pt; clip: rect(0.5pt, 101.6pt, 19.5pt, 0pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext001" style="left: 21.4pt; top: 2.41pt"
              >沒辦法吃</span
            >
          </div>
        </div>
        <div class="wcdiv" style="top: 18.5pt">
          <div class="wcdiv" style="clip: rect(0.5pt, 29.55pt, 19.5pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >1.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0.5pt, 204.35pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >硬豆干</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0.5pt, 101.55pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-1.硬豆干", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0.5pt, 101.55pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-1.硬豆干", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0.5pt, 101.6pt, 19.5pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-1.硬豆干", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 37pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >2.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >炒花生</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-2.炒花生", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-2.炒花生", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-2.炒花生", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 55pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >3.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >芭樂(整顆)</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-3.芭樂(整顆)", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-3.芭樂(整顆)", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-3.芭樂(整顆)", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 73pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >4.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >炸雞</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-4.炸雞", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-4.炸雞", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-4.炸雞", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 91pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >5.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >水煮玉米(整枝)</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-5.水煮玉米(整枝)", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-5.水煮玉米(整枝)", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-5.水煮玉米(整枝)", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 109pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >6.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >蘋果/梨子/蓮霧/芭樂(切片)</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{
                  ifq("2-6.蘋果/梨子/蓮霧/芭樂(切片)", "0.容易吃", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{
                  ifq("2-6.蘋果/梨子/蓮霧/芭樂(切片)", "1.有些吃力", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{
                  ifq("2-6.蘋果/梨子/蓮霧/芭樂(切片)", "2.沒辦法吃", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 127pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >7.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >烤魷魚/雞胗</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-7.烤魷魚/雞胗", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-7.烤魷魚/雞胗", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-7.烤魷魚/雞胗", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 145pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >8.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >水煮花枝/滷豬耳朵</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-8.水煮花枝/滷豬耳朵", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{
                  ifq("2-8.水煮花枝/滷豬耳朵", "1.有些吃力", "■", "□")
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{
                  ifq("2-8.水煮花枝/滷豬耳朵", "2.沒辦法吃", "■", "□")
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 163pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 3.13pt; top: 2.13pt"
                >9.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >柳丁(有切片)</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-9.柳丁(有切片)", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-9.柳丁(有切片)", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-9.柳丁(有切片)", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 181pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >10.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >竹筍/敏豆/花椰菜/切片的小黃瓜</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{
                  ifq(
                    "2-10.竹筍/敏豆/花椰菜/切片的小黃瓜",
                    "0.容易吃",
                    "■",
                    "□"
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{
                  ifq(
                    "2-10.竹筍/敏豆/花椰菜/切片的小黃瓜",
                    "1.有些吃力",
                    "■",
                    "□"
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{
                  ifq(
                    "2-10.竹筍/敏豆/花椰菜/切片的小黃瓜",
                    "2.沒辦法吃",
                    "■",
                    "□"
                  )
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 199pt">
          <div class="wcdiv" style="clip: rect(0pt, 29.55pt, 19pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >11.</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 29.55pt; clip: rect(0pt, 204.35pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >煮熟的紅/白蘿蔔</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 233.9pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-11.煮熟的紅/白蘿蔔", "0.容易吃", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 335.45pt; clip: rect(0pt, 101.55pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.13pt; top: 2.13pt"
                >{{ ifq("2-11.煮熟的紅/白蘿蔔", "1.有些吃力", "■", "□") }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 437pt; clip: rect(0pt, 101.6pt, 19pt, 0pt)"
          >
            <div class="wcdiv" style="left: 5.4pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 39.15pt; top: 2.13pt"
                >{{ ifq("2-11.煮熟的紅/白蘿蔔", "2.沒辦法吃", "■", "□") }}</span
              >
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 217pt">
          <div class="wcdiv" style="clip: rect(0.5pt, 538.6pt, 19.5pt, 0pt)">
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 0pt; top: 2.13pt"
                >總計：</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 50pt; top: 0pt"
                >&nbsp;{{ scoreB }}</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 87.5pt; top: 2.13pt"
                >種(有些吃力+沒辦法吃)</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 218.75pt; top: 2.13pt"
                >&nbsp;</span
              >
              <span
                class="wcspan wctext001"
                style="font-size: 12.5pt; left: 237.5pt; top: 2.13pt"
                >(注意：若種類≧ 4 種，即「可能」有咀嚼障礙風險</span
              >
              <div
                class="wcdiv"
                style="
                  left: 37.5pt;
                  top: 14.34pt;
                  width: 50pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
            </div>
          </div>
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 0pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 18.5pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 217pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 235.5pt;
            width: 538.6pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="top: 550.4pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 14pt;
            left: 171.3pt;
            top: 1.41pt;
            line-height: 16.79pt;
          "
          >--何時需要就醫？掛什麼科？--</span
        >
      </div>
      <div class="wcdiv" style="top: 568.59pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >當咀嚼吞嚥困難發生且無法改善時，需要尋求醫療團隊的協助，不能延遲!</span
        >
      </div>
      <div class="wcdiv" style="top: 584.84pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >一般有「咀嚼困難」</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 106.25pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >，最常尋找的是牙科醫師。</span
        >
      </div>
      <div class="wcdiv" style="top: 601.09pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >若是「吞嚥困難」</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 93.75pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >，復健科及耳鼻喉科是最常處理這類問題的醫師。</span
        >
      </div>
      <div class="wcdiv" style="top: 617.34pt">
        <span
          class="wcspan wctext001"
          style="
            font-size: 12.5pt;
            left: 0pt;
            top: 1.26pt;
            line-height: 14.99pt;
          "
          >必要時會再轉介語言治療師進行評估及訓練，以及其他醫療團隊的協助，如營養師、護理師等等。</span
        >
      </div>
      <div class="wcdiv" style="top: 649.83pt">
        <div
          class="wcdiv"
          style="
            left: -0.05pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 63.95pt;
            top: -0.05pt;
            width: 15.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 79.95pt;
            top: -0.05pt;
            width: 63.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 143.95pt;
            top: -0.05pt;
            width: 23.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 167.95pt;
            top: -0.05pt;
            width: 47.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <div
          class="wcdiv"
          style="
            left: 215.95pt;
            top: -0.05pt;
            width: 7.9pt;
            height: 20.7pt;
            background-color: #d8d8d8;
            border: solid 0.1pt #d8d8d8;
          "
        >
          &nbsp;
        </div>
        <span
          class="wcspan wctext002"
          style="font-size: 16pt; left: 0pt; top: 1.61pt; line-height: 19.19pt"
          >第八部分：衰弱評估(60歲以上)</span
        >
      </div>
      <div class="wcdiv" style="left: 3.1pt; top: 670.63pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >1.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 18.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >非刻意減重狀況下，過去一年體重減少3公斤或5%以上?</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 330.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 395.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "1.非刻意減重狀況下，過去一年體重減少3公斤或5%以上?",
              "0.否",
              "■",
              "□"
            )
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 453.7pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "1.非刻意減重狀況下，過去一年體重減少3公斤或5%以上?",
              "1.是",
              "■",
              "□"
            )
          }}1.是</span
        >
      </div>
      <div class="wcdiv" style="left: 3.1pt; top: 687.53pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >2.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 18.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >無法在不用手支撐的情況下，從椅子上站起來五次?(15秒內)</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 362.7pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 395.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "2.無法在不用手支撐的情況下，從椅子上站起來五次?(15秒內)",
              "0.否",
              "■",
              "□"
            )
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 453.7pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq(
              "2.無法在不用手支撐的情況下，從椅子上站起來五次?(15秒內)",
              "1.是",
              "■",
              "□"
            )
          }}1.是</span
        >
      </div>
      <div class="wcdiv" style="left: 3.1pt; top: 704.43pt">
        <span
          class="wcspan wctext001"
          style="font-size: 13pt; left: 0pt; top: 1.31pt; line-height: 15.59pt"
          >3.</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 18.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >過去一週內，是否覺得提不起勁來做事?</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 245.7pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 395.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("3.過去一週內，是否覺得提不起勁來做事?", "0.否", "■", "□")
          }}0.否</span
        >
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 434.2pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
        >
        </span>
        <span
          class="wcspan wctext001"
          style="
            font-size: 13pt;
            left: 453.7pt;
            top: 1.31pt;
            line-height: 15.59pt;
          "
          >{{
            ifq("3.過去一週內，是否覺得提不起勁來做事?", "1.是", "■", "□")
          }}1.是</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  mixins: [MixinBigQuiz],
  computed: {
    scoreA() {
      let items = [
        "1-1.吞嚥問題讓我的體重減輕",
        "1-2.因為吞嚥問題不能在外面用餐",
        "1-3.我喝飲料/水很費力",
        "1-4.我吃固體食物很費力",
        "1-5.我吞藥丸很費力",
        "1-6.吞嚥會感覺到痛",
        "1-7.因為吞嚥問題不能享受用餐",
        "1-8.吞嚥後感覺喉嚨有食物卡著",
        "1-9.當我進食的時候會咳嗽",
        "1-10.吞嚥讓我感覺緊張有壓力",
      ];
      items = items
        .map((o) => this.keyTrim(o))
        .map((o) => {
          let value = this.ift(o);
          return parseInt(value?.split(".")[0] || 0);
        });

      return _.sum(items);
    },
    scoreB() {
      let items = [
        "2-1.硬豆干",
        "2-2.炒花生",
        "2-3.芭樂(整顆)",
        "2-4.炸雞",
        "2-5.水煮玉米(整枝)",
        "2-6.蘋果/梨子/蓮霧/芭樂(切片)",
        "2-7.烤魷魚/雞胗",
        "2-8.水煮花枝/滷豬耳朵",
        "2-9.柳丁(有切片)",
        "2-10.竹筍/敏豆/花椰菜/切片的小黃瓜",
        "2-11.煮熟的紅/白蘿蔔",
      ];
      // let totalCount = items.length;
      items = items
        .map((o) => this.keyTrim(o))
        .map((o) => {
          let value = this.ift(o);
          let score = parseInt(value?.split(".")[0] || 0);
          return score === 1 || score === 2 ? 1 : 0;
        });

      return _.sum(items);
    },
  },
};
</script>
